<script setup>
import { useNewsFeedStore } from "@/store/NewsFeed/newsFeed";
import { t } from "@/controllerLK/GlobusLocalization";
import { defineProps } from "vue";
import SearchIcon from "@/components/Icons/SearchIcon.vue";
import NewsPageSearchSwitcher from "@/components/NewsPage/NewsPageRoof/NewsPageSearchSwitcher.vue";

defineProps({
  newsPageRoofWidth: {
    type: Number,
    required: true,
  },
});

const store = useNewsFeedStore();

const search = () => {
  store.currentPage = 0;
  store.offset = 0;
  store.facetSearch(store.searchValue);
};

const searchFromButton = () => {
  store.resetChosenCardList();
  search();
};
</script>

<template>
  <InputSearchPrimary
    v-model="store.searchValue"
    style="width: 100%; min-width: 160px"
    size="large"
    :use-search-icon="false"
    :placeholder="t('news_page_body_roof.placeholder.search')"
    @keydown.enter="search"
    @clear-input="search"
  >
    <template #suffix>
      <NewsPageSearchSwitcher />
    </template>
  </InputSearchPrimary>
  <ButtonAccentPrimary
    :style="newsPageRoofWidth >= 1400 ? 'min-width: 120px;' : ''"
    size="large"
    @click="searchFromButton"
  >
    <SearchIcon />
    {{ t("news_page_body_roof.button.find") }}
  </ButtonAccentPrimary>
</template>
